import React, { useEffect } from 'react';
import { createPortal } from 'react-dom';
import { styled } from 'styled-components';

interface FullscreenModalProps {
	open: boolean;
	onClose: () => void;
	children: React.ReactNode;
}

const FullscreenModal: React.FC<FullscreenModalProps> = ({
	open,
	onClose,
	children,
}) => {
	useEffect(() => {
		const handleKeyDown = (event: KeyboardEvent) => {
			if (event.key === 'Escape' && open) {
				onClose();
			}
		};

		document.addEventListener('keydown', handleKeyDown);
		return () => {
			document.removeEventListener('keydown', handleKeyDown);
		};
	}, [open, onClose]);

	useEffect(() => {
		if (open) {
			document.body.style.overflow = 'hidden';
		} else {
			document.body.style.overflow = 'unset';
		}

		return () => {
			document.body.style.overflow = 'unset';
		};
	}, [open]);

	if (!open) return null;

	const modalContent = (
		<ModalBackdrop onClick={onClose}>
			<ModalContent onClick={(e) => e.stopPropagation()}>
				{children}
			</ModalContent>
		</ModalBackdrop>
	);

	return createPortal(modalContent, document.body);
};

const ModalBackdrop = styled.div`
	position: fixed;
	top: 0;
	left: 0;
	width: 100vw;
	height: 100vh;
	background-color: ${({ theme }) => theme.palette.background.default};
	z-index: 9999;
	display: flex;
	flex-direction: column;
`;

const ModalContent = styled.div`
	flex: 1;
	display: flex;
	flex-direction: column;
	width: 100%;
	height: 100%;
`;

export default FullscreenModal;
